export default {
    methods: {
        translateRequestOrderProductsToReceipt(requestOrderProducts) {
            // produto  quantidade  valor unitário  total
            const products = []
            requestOrderProducts.forEach(requestOrderProduct => {
                const product = this.VXORM.Product.find(requestOrderProduct.productId)
                if(product) {
                    const quantity = requestOrderProduct.quantity
                    const unitPrice = (requestOrderProduct.unitPrice - requestOrderProduct.unitDiscount).toFixed(2)
                    const totalPrice = (parseFloat(unitPrice) * quantity).toFixed(2)
                    products.push(`${this.addSpaces(product.name, 19, false)} ${this.addSpaces(quantity + '', 4)} ${this.addSpaces(unitPrice.replace('.', ','), 7)} ${this.addSpaces(totalPrice.replace('.', ','), 7)}`)
                }
            })
            return products
        },

        translateRequestOrderPaymentsToReceipt(requestOrderPayments) {
            const paymentMethods = []
            requestOrderPayments.forEach(requestOrderPayment => {
                const paymentMethod = this.VXORM.PaymentMethod.find(requestOrderPayment.paymentMethodId)
                if(paymentMethod) {
                    paymentMethods.push(`${this.addSpaces(paymentMethod.name.toUpperCase(), 40, false)}`)
                }
            })
            return paymentMethods
        },

        translateContactAddressToReceipt(contactAddress) {
            const addressLines = []
            if(!contactAddress) return addressLines

            const address = {
                name: contactAddress.address && contactAddress.address.name ? `END: ${contactAddress.address.name}` : '',
                number: contactAddress.number ? `NUM: ${contactAddress.number}` : '',
                neighborhood: contactAddress.address && contactAddress.address.neighborhood ? `BAIRRO: ${contactAddress.address.neighborhood}` : '',
                complement: contactAddress.complement ? `COMP: ${contactAddress.complement}` : '',
                referencePoint: contactAddress.referencePoint ? `REF: ${contactAddress.referencePoint}` : '',
                city: contactAddress.address && contactAddress.address.city ? `CID: ${contactAddress.address.city} - ${contactAddress.address.state}` : '',
                postalCode: contactAddress.address && contactAddress.address.cep ? `CEP: ${contactAddress.address.cep}` : ''
            }
            for(const key in address) {
                const _address = address[key] 
                if(_address) addressLines.push(this.addSpaces(_address, 40, false))
            }
            return addressLines
        },

        addSpaces(text, maxLength, atTheBeginning = true) {
            if(text.length >= maxLength) 
                return text.substr(0, maxLength)
                
            const diff = maxLength - text.length

            let spaces = ''
            for(let i = 0; i < diff; i++) {
                spaces += ' '
            }
 
            return atTheBeginning ? spaces += text : text += spaces
        },

        centralizeText(text, columns = 40) {
            if(text === null) return ' '
            const _text = text

            let formattedText
            if(_text.length < columns) {
                let spaces = Math.floor((columns - _text.length) / 2)
                let space = ''
                for(let i = 0; i < spaces; i++) {
                    space += ' '
                } 
                formattedText = space += _text
            }
            else {
                formattedText = _text.substr(0, columns)
            }
            return formattedText
        },

        breakLine(text, columns = 40, linesLimit = 3) {
            const lines = []
            if(text.length > columns) {
                let textSubStr = text.substring(0, columns) 
                lines.push(textSubStr)
                
                let _columns = columns
                for(let i = 1; i < linesLimit; i++) {
                    lines.push(text.substring(_columns, columns * (i + 1)))
                    _columns = columns * (i + 1)
                }
            }
            else 
                lines.push(text)
            
           return lines
        },

        formatValues({
            requestCode,
            requestObs,
            companyName,
            companyCnpj,
            products,
            subtotal,
            discount,
            total,
            paymentMethods,
            contactCpf,
            contactName,
            contactAddress
        }) {
            const skipLine = '-'.repeat(40)
            const header = {
                requestCode,
                companyName,
                companyCnpj
            }

            const lines = []
            const _requestCode = this.centralizeText(`PEDIDO Nº ${requestCode ? requestCode : ''}`)
            const _requestObs = this.centralizeText(this.addSpaces(`OBS: ${requestObs ? requestObs : ''}`, 40, false))
            const _companyName = this.centralizeText(header.companyName)
            const _companyCnpj = this.centralizeText(header.companyCnpj)
            const _headerItens = `${this.addSpaces('Produto', 19, false)}${this.addSpaces('QNT', 5)}${this.addSpaces('V. UN', 8)}${this.addSpaces('Total', 8)}`.toUpperCase()
            const _subtotal = this.addSpaces(`SUBTOTAL ${subtotal}`, 40, true)
            const _discount = this.addSpaces(`DESCONTO ${discount}`, 40, true)
            const _total = this.addSpaces(`TOTAL R$${total}`, 40, true)
            const _contactName = this.centralizeText(`${contactName}`)
            const _contactCpf = this.centralizeText(`${contactCpf}`)
            
            lines.push(_requestCode)
            lines.push('')
            lines.push(_companyName)
            lines.push(_companyCnpj)
            lines.push(skipLine)
            lines.push('')
            lines.push(_headerItens)
            products.forEach(product => {
                lines.push(product)
            })
            lines.push('')
            lines.push(_subtotal)
            lines.push(_discount)
            lines.push('')
            lines.push(_total)
            lines.push('')
            lines.push('PAGAMENTO')
            paymentMethods.forEach(paymentMethod => {
                lines.push(paymentMethod)
            })
            lines.push('')
            lines.push(skipLine)
            lines.push('')
            lines.push(_contactName)
            lines.push(_contactCpf)
            lines.push('')
            if(contactAddress && Array.isArray(contactAddress)) 
                contactAddress.forEach(_contactAddress => {
                    lines.push(_contactAddress)
                })
            lines.push('')
            this.breakLine(_requestObs)
                .forEach(obsLines => {
                    lines.push(obsLines)
                })

            return lines.join('\n')
        }
    }
}